import { Component } from '@angular/core';

@Component({
  selector: 'pla-privacy-policy-page',
  templateUrl: './privacy-policy-page.component.html',
  styleUrls: ['../legal-page/legal-page.scss']
})
export class PrivacyPolicyPageComponent {
  /** Opens the FreePrivacyPolicy cookie preferences centre (loaded in index.html). */
  public openCookiePreferences(): void {
    const cc = (window as any).cookieconsent;
    if (cc && typeof cc.openPreferencesCenter === 'function') cc.openPreferencesCenter();
  }
}
